import { Layout } from "antd";
import { styled, css } from "styled-components";

const { Content } = Layout;

const VARIANTS_CONTENT_MAIN = {
	appBg: css`
        background-color: ${({ theme }) => theme?.colors?.theme?.appBg};
    `,
	white: css`
        background-color: ${({ theme }) => theme?.colors?.common?.white};
    `,
	gradientBlue: css`
        background: linear-gradient(180deg, #001651 0%, #590DF2 100%);
    `,
	gradientPurple: css`
        position: relative;
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(180deg, rgba(141, 13, 242, 0.50) 0%, ${({ theme }) => theme?.colors?.theme?.appBg} 100%);
            opacity: 0.3;
            z-index: 0;
            pointer-events: none;
        }

        & > * {
            position: relative;
            z-index: 1;
        }
    `,
	gradientBlack: css`
        position: relative;
        
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0.3;
            background: linear-gradient(180deg, rgba(141, 13, 242, 0.10) 0%, ${({ theme }) => theme?.colors?.theme?.appBg} 100%);
            z-index: 0;
            pointer-events: none;
        }

        & > * {
            position: relative;
            z-index: 1;
        }
    `
};

const ContentMain = styled(Content)<{ variant: keyof typeof VARIANTS_CONTENT_MAIN }>`
    display: flex;
    padding: 32px 16px;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    align-self: stretch;
    margin: 0 auto;
    min-height: 100%;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    ${({ variant }) => VARIANTS_CONTENT_MAIN[variant]}
`;


export {
	ContentMain
};
